import { ChangeDetectorRef, Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ProfileService } from '../services/profile.service';
import { ResultService } from '../services/result.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSelect } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../services/user.service';
import { filter } from 'rxjs/operators';
import { CompanyDetailsService } from '../services/company-details.service';
// import { SnotifyService } from '../../../node_modules/ng-snotify';
import { PaymentService } from '../services/payment.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessagesComponent } from '../messages/messages.component';
import { MatDialog } from '@angular/material/dialog';
import { MediaMatcher } from '@angular/cdk/layout';
import { LoaderService } from '../services/loader.service';
import { FeedbackService } from '../services/feedback.service';
import { ConfirmSnackbarComponent } from '../confirm-snackbar/confirm-snackbar.component';
import { PayperbyteWarnDialogComponent } from '../payperbyte-warn-dialog/payperbyte-warn-dialog.component';
import { PayperbyteService } from '../services/payperbyte.service';
import { ClassService } from '../services/class.service';
import { Router } from '@angular/router';
import { LogService } from '../services/log.service';

export interface Payment {
    payment_id: number;
    termd_id: string;
    reference: string;
    slip: string | null;
    amount: string;
    payment_date: string | null;
    purpose: string;
    status: string;
    rejection_reason: string | null;
    created_at: Date;
}


// import { MessagesComponent } from '../messages/messages.component';

@Component({
    selector: 'app-course-registration',
    templateUrl: './course-registration.component.html',
    styleUrls: ['./course-registration.component.css']
})
export class CourseRegistrationComponent implements OnInit, OnDestroy {
    @Output()
    selectionChange: EventEmitter<MatSelect>
    public isCourseRegClosed = false;
    public courses;
    public studentDept;
    public studentLevel;
    public semester;
    public test;
    public options;
    public _value;
    public course;
    public reg_courses;
    public i;
    public j;
    public k;
    public l;
    public m;
    public house = [];
    public separator = [];
    public cd;
    public c = [];
    public d = [];
    public u = [];
    public idd = [];
    public sum = [];
    public g;
    public taxi;
    public bus = [];
    public filteredItems;
    public items;
    public courr = [];
    public extra;
    public extraCourses;
    public extraCoursesArray;
    public unitSum;
    public unitSum2;
    public searchText;
    public currentSemester;
    public cs;
    public sessionYear;
    public courseRegForm: FormGroup;
    public studentDetails: any = [];
    public deptCourses;
    public selectedCourses;
    public registeredSemesterCourses;
    public deptc; public cd_id;
    public allCourses;
    public showDropDown = false;
    public totalUnits = 0;
    public company_initial;
    public company_logo;
    public company_name;
    public company_address;
    public studentPassport;
    public firstname: string;
    public lastname: string;
    public middlename;
    public student_id;
    public constr;
    public isFullyLoaded;
    public responseExists = false;
    public cresponse = "";
    public isActivated = null;
    public activationMessage;
    public activationExtra;
    public summer;
    public summerSemesterModel;
    public summerSemesterOptions;
    public selectedSummerSemester: any = 1;
    public src = null;
    public isPenaltyPeriod = null;
    public penaltyFee = 0;
    public totalPenaltyFee;
    public class_description;
    public baseUrl;
    public scloaded = true;
    public dcloaded = true;
    public selectedSemeterData;
    public companyBanner;
    stateForm: FormGroup;
    mobileQuery: MediaQueryList;
    public bannerFound = true;
    public penaltyStarts;
    public courseRegEnds;
    public matric_no;
    public extra_co;
    public charge = 300;
    interswitchOptions = {};
    public reg_both_semesters;
    courseRegPayments: Payment[] = [];
    receiptData: Payment | null;
    public readOnly = false;
    private _mobileQueryListener: () => void;
    paymentGateway: any;
    studentData: any;

    constructor (changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private _profileService: ProfileService,
        private _userService: UserService, public _class: ClassService, public router: Router,
        private _resultService: ResultService, private bottomSheet: MatBottomSheet,
        private spinner: NgxSpinnerService, private fb: FormBuilder, private _companyDetailsService: CompanyDetailsService,
        private _paymentService: PaymentService, private _loaderService: LoaderService, private _feedbackService: FeedbackService,
        public snackBar: MatSnackBar, public payperbyteService: PayperbyteService, public log: LogService, private dialog?: MatDialog) {
        this.constr = this;
        this.courseRegForm = this.fb.group({
            selectedCourses: [''],
            summerSemester: [''],
            search: [null]
        })
        //this.initForm();

        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }
    // initForm(): FormGroup {
    //   return this.stateForm = this.fb.group({
    //     search: [null]
    //   })
    // }


    public payperbyte = 0;
    public paymentEligible: any = { control: true };

    joinVirtualClass (co_id) {
        this._paymentService.getPaymentEligibility({ key: 'v_class' }).subscribe(data => {
            this.paymentEligible = data;
            if (this.paymentEligible.control == false) {
                if (!this.paymentEligible.control) {
                    this.dialog.open(MessagesComponent, {
                        disableClose: true,
                        data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to write tests/exams` }
                    })
                }
                return;
            } else {
                let form = new FormData();
                form.append('co_id', co_id)
                form.append('cd_id', this.cd_id)
                this._class.joinVirtualClass({ co_id }).subscribe(data => {
                    if (data.success) {
                        this.log
                            .addLog({
                                action: "Join",
                                component: "Course Registration",
                                details: `Joined Virtual Class with title - ${data.title}`,
                            }).subscribe(data => { });
                        localStorage.setItem("tmp_class_code", data.code);
                        localStorage.setItem("tmp_class_name", data.title);
                        sessionStorage.setItem('edoz_name', `${this.lastname} ${this.firstname}`)
                        this.router.navigate(['home/virtual-class'])
                    }
                })
            }
        })
    }

    ngOnInit () {
        this.log
            .addLog({
                action: "Access",
                component: "Course Registration",
                details: `Access Course Registration`,
            }).subscribe(data => { });
        this._paymentService.getPaymentEligibility({ key: 'course_reg' }).subscribe(data => {
            this.paymentEligible = data;
        });
        // this._userService.getPrograms().subscribe(data => {
        //     let system_current_st_pr_id = data[0].st_pr_id;
        //     this._userService.programEmitted$.subscribe(data => {
        //         if(system_current_st_pr_id !== data.st_pr_id){
        //             this.readOnly = true;
        //         }else{
        //             this.readOnly = false;
        //         }
        //     })
        // })
        this.baseUrl = this._companyDetailsService.getBaseUrl();
        this._loaderService.emitChange(true);
        this.courr = this._profileService.getAllCourses();
        this.courses = this._profileService.getCourse('', '');
        this.studentDept = this._profileService.getDept();
        //this.studentLevel = this._profileService.getLevel();
        this.semester = this._profileService.getSemester();
        // this.studentDetails = this._profileService.studentDetails;

        this._companyDetailsService.getDetails().subscribe(data => {
            this.paymentGateway = data.payment_gateway;
            this.company_initial = data.adm_initial;
            this.company_logo = data.logo;
            this.company_name = data.name;
            this.company_address = data.address;
            this.companyBanner = data.path;
        });

        this._userService.getUserData().subscribe(data => {
            this.currentSemester = data.term;
            this.sessionYear = data.session_year;
            this.cd_id = data.cd_id;
            this.studentPassport = data.passport;
            this.firstname = data.firstname;
            this.lastname = data.lastname;
            this.middlename = data.middlename;
            this.student_id = data.student_id;
            this.matric_no = data.matric_no;
            this.studentLevel = data.tag;
            this.payperbyte = data.payperbyte;
            this.summer = data.summer;
            this.extra_co = data.extra_co;
            this.reg_both_semesters = data.reg_both_semesters;
            this.studentData = data;

            if (this.currentSemester == 'First Semester') {
                this.cs = 1;
            } else if (this.currentSemester == 'Second Semester') {
                this.cs = 2;
            }

            //load courses for the current semester only, if not a sandwich student
            if (this.summer === 'N') {
                this.dcloaded = false;
                this._resultService.loadCourses()
                    .subscribe(data => {
                        if (this.reg_both_semesters == '1') {
                            this.deptCourses = data.filter(x => (x.student_id == this.student_id));
                        } else {
                            this.deptCourses = data.filter(x => (x.student_id == this.student_id && x.semester == this.cs));
                        }
                        this.dcloaded = true;
                    });

            } else if (this.summer === 'Y') {
                this._loaderService.emitChange(false);
                //if a sandwich student, load courses based on semester chosen in the current session

                //load available semesters
                this._resultService.loadSummerSemesters()
                    .subscribe(data => {
                        this.summerSemesterOptions = data;
                        this.selectedSummerSemester = { value: this.summerSemesterOptions[0].term_id, text: "First Semester" }
                        this.courseRegForm.controls['summerSemester'].setValue(this.selectedSummerSemester.value)
                        this.summerChangeSemester("");
                    })
                //first semester courses are displayed onload
                this._resultService.loadCourses()
                    .subscribe(data => {
                        this.deptCourses = data.filter(x => (
                            x.student_id == this.student_id && (x.semester == 1)
                        ));

                    });


            }
            this.courseRegForm.controls['summerSemester'].setValue(this.selectedSummerSemester.value)


            //check if course reg is closed for the semester
            this._resultService.getSemesterInfo().subscribe(rdata => {
                //get current date
                let prog_reg_end = rdata.prog.course_reg_ends;
                let prog_penalty = rdata.prog.penalty_starts;

                if (prog_reg_end && prog_penalty) {
                    // console.log("PROG LIMIT")
                    this.penaltyStarts = prog_penalty;
                    this.courseRegEnds = prog_reg_end;

                    rdata.penalty_starts = prog_penalty;
                    rdata.course_reg_ends = prog_reg_end;

                    // console.log(data);
                } else {
                    this.penaltyStarts = rdata.penalty_starts;
                    this.courseRegEnds = rdata.course_reg_ends;
                }
                this._resultService.getCurrentDate().subscribe(data2 => {
                    let date_today = new Date(data2.today).getTime();

                    let cre = rdata.course_reg_ends;
                    let d = new Date(cre);
                    let courseRegCloses = d.getTime();
                    //check if in penalty period
                    let penaltyDate = new Date(rdata.penalty_starts).getTime();
                    let beginDate = new Date(rdata.begins).getTime();
                    // console.log(penaltyDate," ", beginDate);
                    if (courseRegCloses - date_today <= 0) {
                        this.isCourseRegClosed = true;
                    } else if (penaltyDate < beginDate || typeof (rdata.penalty_amount) == 'undefined' || rdata.penalty_amount <= 0) {
                        this.isPenaltyPeriod = 'no';//this is to ensure payment is not demanded when
                        //penalty date is less than begin date e.g when penalty date is 0000-00-00( or not set )
                    } else if (penaltyDate - date_today <= 0) {
                        this._paymentService.isPenaltyPaid().subscribe(data => {
                            if (data.paid.late_registration == 'Y') {
                                this.isPenaltyPeriod = 'no';
                                // this.isCourseRegClosed = false;
                            } else {
                                this.isPenaltyPeriod = 'yes';
                            }
                        })

                        let penaltyInDays = Math.floor((date_today - penaltyDate) / 1000 / 60 / 60 / 24);
                        this.penaltyFee = rdata.penalty_amount;
                        const fee = {
                            "0d": this.penaltyFee,
                            "1d": (penaltyInDays * (Number(rdata.increment_amount))) + (Number(rdata.penalty_amount)),
                            "7d": ((Math.floor(penaltyInDays / 7)) * Number(rdata.increment_amount)) + Number(rdata.penalty_amount),
                            "14d": ((Math.floor(penaltyInDays / 14)) * Number(rdata.increment_amount)) + Number(rdata.penalty_amount),
                            "30d": ((Math.floor(penaltyInDays / 30)) * Number(rdata.increment_amount)) + Number(rdata.penalty_amount),
                        }[rdata.increment_pattern];

                        this.penaltyFee = (!!Number(rdata.max_penalty_amount) && fee > rdata.max_penalty_amount) ? rdata.max_penalty_amount : fee;

                        if (this.paymentGateway.includes('interswitch')) {
                            this.totalPenaltyFee = Number(this.penaltyFee) + Number(this.charge);
                            this.interswitchOptions = {
                                merchantCode: 'MX18777',
                                payItemID: 'Default_Payable_MX18777',
                                transactionReference: Date.now().toString(),
                                amount: this.totalPenaltyFee * 100,
                                customerEmail: data.email,
                                customerName: `${this.firstname} ${this.lastname}`,
                                paymentMode: 'LIVE'
                            }
                        }

                        if (this.paymentGateway.includes('paystack')) {
                            let charge = (this.penaltyFee * 1.5 / 100) + 100;
                            this.charge = Math.round(charge < 2000 ? charge : 2000)
                            this.totalPenaltyFee = Number(this.charge) + Number(this.penaltyFee);
                        }
                    } else if (penaltyDate - date_today > 0) {
                        this.isPenaltyPeriod = 'no';
                    }
                })
            });
        });


        //fetch all courses from db
        this._resultService.loadAllCourses()
            .subscribe(data => {
                if (data) {
                    this.allCourses = data.map(each => ({
                        ...each,
                        disabled: Number(each?.sub_obsolete),
                        course_unit: Number(each?.sub_obsolete) ? `${each.course_unit} - OBSOLETE` : each.course_unit
                    }));
                }
            })


        //fetch registered courses on load
        this._resultService.sem_reg_courses().subscribe(data => {
            data = data.slice(0, data.length - 2); //remove the last two items in the array  ['success', 'message']
            for (let i in data) {
                this.totalUnits += data[i].unit;
            }

            this.registeredSemesterCourses = data;
            //check if there are registered courses for the semester
            if (this.registeredSemesterCourses.length > 0) {
                this.responseExists = true;
                this.cresponse = "";
            } else {
                this.responseExists = false;
                this.cresponse = "No registered courses for this semester";
            }
            this._loaderService.emitChange(false);
        })

        //check if student has paid for the app
        this._resultService.checkSubscriptionStatus().subscribe(data => {
            if (data.success) {
                this.isActivated = "activated";
            } else {
                this.isActivated = "not-activated"
            }
            this.activationMessage = data.message;
            this.activationExtra = data.extra;
        })

        this._resultService.semesterCourseRegPayments().subscribe(data => {
            if (!data.success) return;
            this.courseRegPayments = data.data;
        })

    }

    summerChangeSemester (event) {
        // this.scloaded = false;
        // let target = event.source.selected._element.nativeElement;
        // let selectedData = {
        //   value: event.value,
        //   text: target.innerText.trim()
        // };
        // this.selectedSemeterData = selectedData;
        // this.selectedSummerSemester = selectedData;
        //display courses based on selected semester by summer student
        let selectedData = this.selectedSummerSemester;
        this._resultService.changeSemester(this.selectedSummerSemester)
            .subscribe(data => {
                //console.log(data);
                if (this.summer == 'Y') {
                    let dataSuccess = data[data.length - 2] //check the  second last item of the response array which is an object
                    //for the value of 'success'
                    let dataMessage = data[data.length - 1] //last item in array (message)

                    data = data.slice(0, data.length - 2);//remove the last two item in the array which is 'success
                    this.registeredSemesterCourses = data;
                    this.totalUnits = 0;
                    for (let i in data) {
                        this.totalUnits += data[i].unit;
                    }
                    this.responseExists = true;
                    this._loaderService.emitChange(false);
                    this.scloaded = true;
                    //console.log(this.registeredSemesterCourses);
                }
            })

        //if first semester
        if (selectedData.text == 'First Semester') {
            this._resultService.loadCourses()
                .subscribe(data => {
                    this.deptCourses = data.filter(x => (
                        x.student_id == this.student_id && (x.semester == 1)
                    ));
                    //console.log(this.deptCourses);

                });
        }
        // else if(selectedData.text == 'Second Semester'){
        //     //if second semester
        //     this._resultService.loadCourses()
        //     .subscribe(data => {
        //         this.deptCourses = data.filter(x => (
        //             x.student_id == this.student_id && (x.semester == 2)
        //             ));
        //            // console.log(this.deptCourses);

        //     });
        // }
    }

    handlePaymentInterswitch (resp) {
        // console.log(resp);
        let amount = resp.amount;
        let withoutCharge = (amount / 100) - this.charge;
        // withoutCharge = withoutCharge * 100;
        let form = {
            amount,
            withoutCharge: withoutCharge,
            student_name: `${this.firstname} ${this.lastname}`,
            reference: resp.txnref,
            purpose: "late_reg",
        };

        if (resp.resp == '00') {
            this._loaderService.emitChange(true)
            this._paymentService.recordPayment(form).subscribe(data => {
                this._loaderService.emitChange(false)
                if (data.success) {
                    this.log
                        .addLog({
                            action: "Pay",
                            component: "Course Reg",
                            details: `Made Payment through Interswitch - ${amount} with reference - ${resp.txnref}`
                        }).subscribe(data => { });
                    this.ngOnInit();
                }
            })
        } else {
            this.snackBar.open("Something went wrong, please try again", "Dismiss", {
                duration: 5000
            });
            this.ngOnInit();
        }
    }


    addCourses (values) {
        //check if any course(s) is selected
        if (values.selectedCourses.length === 0) {
            // console.log("no course selected");
            return;
        }
        //check if student is payperbyte
        if (this.payperbyte == 1) {
            //show dialog to inform about about
            const dialogRef = this.dialog.open(PayperbyteWarnDialogComponent, {
                minWidth: '30%',
                data: { warning: true, paying: false }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (typeof (result) === 'undefined') {
                    // alert();
                }
                else {
                    //if student says to make payment
                    if (result.pay) {
                        let courses = values.selectedCourses;
                        //compute the amount to be paid for the courses selected
                        this.payperbyteService.computePayment({ courses }).subscribe(data => {
                            //display the payment info in a dialog and ask to proceed
                            const dialogRef = this.dialog.open(PayperbyteWarnDialogComponent, {
                                minWidth: '30%',
                                data: { paying: true, warning: false, payment: data }
                            });

                            dialogRef.afterClosed().subscribe(result => {
                                if (typeof (result) === 'undefined') {

                                } else {
                                    //if student says to proceed, proxy to payment endpoint (paystack)
                                    if (result.proceed) {
                                        this.log
                                            .addLog({
                                                action: "Initiate",
                                                component: "Course Registration",
                                                details: `Initiated Payment in  Course Registration`,
                                            }).subscribe(data => { });
                                        // console.log(values);
                                        // return;
                                        let amount = data.amount + data.charges;
                                        this.payperbyteService.payForCourseRegistration({ amount, values }).subscribe(data => {
                                            location.href = data.red_url
                                            if (data.payment_success) {
                                                this.log
                                                    .addLog({
                                                        action: "Payment",
                                                        component: "Course Registration",
                                                        details: `Made Payperbyte Payment in Course Registration `,
                                                    }).subscribe(data => { });
                                                //   this.registerCourses(values)
                                            }
                                        })
                                    }
                                }
                            })
                        })
                        // this._resultService.payForResult({payment: 'result'}).subscribe(data => {
                        //   location.href = data.red_url;

                        // })
                        //   this.registerCourses(values);
                    }
                }
            });
            return;
        }

        this.registerCourses(values);

    }

    registerCourses (values) {
        this._userService.billStudent().subscribe(data => {
            this._paymentService.getPaymentEligibility({ key: 'course_reg' }).subscribe(data => {
                this.paymentEligible = data;
                if (!this.paymentEligible.control) {
                    this.dialog.open(MessagesComponent, {
                        data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to do course registration` }
                    })

                    return;
                }

                if (!navigator.onLine) {
                    this.constr.snackBar.open('You are offline', 'Dismiss');
                    return;
                }
                this._loaderService.emitChange(true);
                let resp = document.querySelector('#resp');
                if (this.summer == 'Y') {
                    // if(values.summerSemester == ''){
                    //     //alert('Please select a semester');;
                    //     this.dialog.open(MessagesComponent,{
                    //         data:{
                    //             message: 'Please select a semester'
                    //         }
                    //     })
                    //     this._loaderService.emitChange(false);

                    // }else{
                    this._resultService.registerCourses(values).subscribe(data => {
                        let dataSuccess = data[data.length - 2] //check the  second last item of the response array which is an object
                        //for the value of 'success'
                        let dataMessage = data[data.length - 1] //last item in array (message)

                        data = data.slice(0, data.length - 2);//remove the last two item in the array which is 'success
                        if (dataSuccess) {
                            this._feedbackService.emitChange("Successful", "primary-color");
                            this.totalUnits = 0;
                            for (let i in data) {
                                this.totalUnits += data[i].unit;
                            }
                            this.log
                                .addLog({
                                    action: "Register",
                                    component: "Course Registration",
                                    details: `Registered a Course`,
                                }).subscribe(data => { });

                        } else {
                            this._feedbackService.emitChange("Failed. " + dataMessage, "failed-color");
                            this.responseExists = false;
                        }
                        this.registeredSemesterCourses = data;
                        this.responseExists = true;
                        this._loaderService.emitChange(false);

                    });
                    // }
                } else if (this.summer == 'N') {
                    this._resultService.registerCourses(values).subscribe(data => {
                        let dataSuccess = data[data.length - 2] //check the  second last item of the response array which is an object
                        //for the value of 'success'
                        let dataMessage = data[data.length - 1] //last item in array (message)

                        data = data.slice(0, data.length - 2);//remove the last two item in the array which is 'success
                        if (dataSuccess) {
                            this._feedbackService.emitChange("Successful", "primary-color");
                            this.totalUnits = 0;
                            for (let i in data) {
                                this.totalUnits += data[i].unit;
                            }
                            this.log
                                .addLog({
                                    action: "Register",
                                    component: "Course Registration",
                                    details: `Registered a Course`,
                                }).subscribe(data => { });

                        } else {
                            this._feedbackService.emitChange("Failed. " + dataMessage, "failed-color");
                            this.responseExists = false;
                        }
                        this.registeredSemesterCourses = data;
                        this.responseExists = true;
                        this._loaderService.emitChange(false);

                    });
                }

            });
        })




    }

    deleteCourse (title, id) {
        if (!navigator.onLine) {
            this.constr.snackBar.open('You are offline', 'Dismiss');
            //return;
        }
        let resp = document.querySelector('#resp');
        let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent, {
            data: { message: "Are you sure?", button1: 'yes', button2: 'no' }
        })
        sheetRef.afterDismissed().subscribe(data => {
            if (data) {
                if (data.response) {
                    this.delCourse(title, id);
                }
            }
        })



    }
    delCourse (title, id) {
        this._loaderService.emitChange(true);
        this._resultService.deleteCourse(id).subscribe(data => {
            // console.log('data::', data);

            let dataSuccess = data[data.length - 2].success //check the  second last item of the response array which is an object
            //for the value of 'success'
            let dataMessage = data[data.length - 1] //last item in array (message)
            data = data.slice(0, data.length - 2);//remove the last two item in the array which is 'success
            this.totalUnits = 0;
            if (dataSuccess) {
                this._feedbackService.emitChange("Successful", "primary-color");
                this.log
                    .addLog({
                        action: "Delete",
                        component: "Course Registration",
                        details: `Deleted Course ${title}`,
                    }).subscribe(data => { });
                for (let i in data) {
                    //console.log('tot: ', this.totalUnits);
                    this.totalUnits += data[i].unit;
                }
                if (this.summer == "N") {
                    this.registeredSemesterCourses = data;

                } else if (this.summer == "Y") {
                    this._resultService.changeSemester(this.selectedSummerSemester)
                        .subscribe(data => {
                            //console.log(data);
                            if (this.summer == 'Y') {

                                let dataSuccess = data[data.length - 2] //check the  second last item of the response array which is an object
                                //for the value of 'success'
                                let dataMessage = data[data.length - 1] //last item in array (message)

                                data = data.slice(0, data.length - 2);//remove the last two item in the array which is 'success
                                this.totalUnits = 0;
                                for (let i in data) {
                                    this.totalUnits += data[i].unit;
                                }
                                this.registeredSemesterCourses = data;
                                this.responseExists = true;
                                this._loaderService.emitChange(false);
                                this.scloaded = true;
                                //console.log(this.registeredSemesterCourses);
                            }
                        })
                }
            } else {
                this._feedbackService.emitChange("Failed. " + dataMessage, "failed-color");
            }
            this._loaderService.emitChange(false);

        });


    }
    hideDataListValue (e) {
        let input = document.getElementById('extra'),
            list = input.getAttribute('list'),
            options = document.querySelectorAll('#' + list + ' option'),
            hiddenInput = document.getElementById(input.id + '-hidden'),
            inputValue = (<HTMLInputElement>input).value;
        (<HTMLInputElement>hiddenInput).value = inputValue;
        for (let i = 0; i < options.length; i++) {
            let option = options[i];
            if ((<HTMLInputElement>option).innerHTML === inputValue) {
                (<HTMLInputElement>hiddenInput).value = option.getAttribute('data-value');
                break;
            }
        }
    }
    calcTotUnit () {
        for (let i = 0; i < this.bus.length; i++) {
            this.unitSum2 += parseInt(this.bus[i][2]);

        }
        document.getElementById('total').innerHTML = this.unitSum2;
    }

    closeDropDown () {
        this.showDropDown = false;
    }

    openDropDown () {
        this.showDropDown = true;
    }
    getSearchValue () {
        return this.courseRegForm.value.search;
    }
    selectValue (value) {
        this.courseRegForm.patchValue({ "search": value });
        this.showDropDown = false;
    }
    addExtraCourses () {
        if (!this.paymentEligible.control) {
            this.dialog.open(MessagesComponent, {
                data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to do course registration` }
            })

            return;
        }
        if (this.getSearchValue() == null) {
            // console.log('no extra course selected');
            return;
        }
        if (!navigator.onLine) {
            this.constr.snackBar.open('You are offline', 'Dismiss');
            return;
        }
        // if(this.summer == 'Y'){
        //     if(this.selectedSummerSemester == undefined){
        //         this.dialog.open(MessagesComponent,{
        //             data:{
        //                 message: 'Please select a semester'
        //             }
        //         })
        //         return;
        //     }

        // }

        this._loaderService.emitChange(true);
        let resp = document.querySelector('#resp');
        let extraCourse = this.getSearchValue();//(<HTMLInputElement>document.querySelector('#extraCourse')).value;
        this._resultService.regExtraCourse({
            extraCourse: extraCourse,
            selectedSummerSemester: this.selectedSummerSemester
        }).subscribe(data => {
            let dataSuccess = data[data.length - 2] //check the  second last item of the response array which is an object
            //for the value of 'success'
            let dataMessage = data[data.length - 1] //last item in array (message)
            data = data.slice(0, data.length - 2);//remove the last two items in the array which is 'success

            if (dataSuccess) {
                this._feedbackService.emitChange("Successful", "primary-color");
                this.totalUnits = 0;
                for (let i in data) {
                    this.totalUnits += data[i].unit;
                }
                this.registeredSemesterCourses = data;
                this.responseExists = true;
                this.log
                    .addLog({
                        action: "Register",
                        component: "Course Registration",
                        details: `Registered Extra Course`,
                    }).subscribe(data => { });
            } else {
                this._feedbackService.emitChange("Failed. " + dataMessage, "failed-color");
                //resp.innerHTML = "Sorry! Courses not registered. Please try again.";
                this.responseExists = false;
            }
            this.registeredSemesterCourses = data;
            this.responseExists = true;
            this._loaderService.emitChange(false);

        });
    }

    handlePayment () {

        return this._paymentService.makeAppPayment().subscribe(data => {
            this.log
                .addLog({
                    action: "Initiate",
                    component: "Course Registration",
                    details: `Initiated Payment in Course Registration`,
                }).subscribe(data => { });
            location.href = data.red_url;
        })
    }

    initiating = false;
    handlePenaltyPayment () {
        this.log.addLog({
            action: "Initiate",
            component: "Course Registration",
            details: `Initiated Penalty Payment in Course Registration`,
        }).subscribe();

        this.initiating = true;
        this._resultService.payForLateRegistration({
            payment: 'late_registration',
            student_name: `${this.firstname.trim()} ${this.lastname.trim()}`,
            amount: this.totalPenaltyFee,
            withoutCharge: this.penaltyFee
        }).subscribe(data => {
            if (data.red_url) {
                location.href = data.red_url;
            } else {
                this.initiating = false;
            }
        }, () => {
            this.initiating = false;
        })
    }


    print () {
        this.log
            .addLog({
                action: "Print",
                component: "Course Registration",
                details: `Printed Course Registration Print Out`,
            }).subscribe(data => { });
        let today = new Date();
        let yyyy = today.getFullYear();
        let courses = this.registeredSemesterCourses;
        let mywindow = window.open('about:parent', 'PRINT', 'height=700,width=1000');
        let logo = this.company_logo;
        let banner = this.baseUrl + "edozzier/" + this.companyBanner;
        let displayData = '';
        displayData += '<html><head><title>' + document.title + '</title>';
        displayData +=
            `<style>
            *{
                text-transform: uppercase
            }
            body{font-family:arial; padding: 0 8%;
                background: linear-gradient(180deg, rgba(255,255,255,0.9), rgba(255, 255,255, 0.9)), url(${logo});
                background-size: 100px 100px;
            } 
            div{float:left;} 
            table{background:none;border-collapse:collapse;width:100%;font-family:arial;font-size:0.85em;border:solid 1px #ccc;margin-top:20px;} 
            th, td{border:solid 1px #ccc;padding:8px 5px; text-align:left;} 
            img{width:70px;height:70px} 
            table#summary tr td{padding-top:40px;text-align:center;} 
            .clearfix{clear:both} table,table#details tr td{border:none}
            .banner h2{
                margin: 7px;
            }
            .banner-container{
                border: solid 2px #777;
                margin-bottom: 5px;
            }
            #banner-logo{
                width: 80px;
                height: 80px;
            }
            #copyright{
                position: absolute; 
                bottom:0; 
                margin-bottom:5px;
                text-align:center !important;
                margin-left: 35%;
                font-size: 0.8em;
            }
            </style>`
            ;
        displayData += "</head><body>";

        displayData +=
            `<div class='banner-container'><div style='width: 15%'>
                <img src = ${logo} alt='logo' id='banner-logo' />
            </div>
            <div style='width:85%; align-text:center' class='banner'>
                <h2>${this.company_name}</h2>
            </div></div>
        `;


        displayData += "<h4 style='text-align:center'>COURSE REGISTRATION PRINT-OUT</h4>";
        displayData += "<h4 style='text-align:center'>" + this.sessionYear + "(" + this.currentSemester + ") |  " + this.studentLevel + "</h4>";
        displayData += "<div style='width:70%; margin-bottom: 10px'>";
        displayData += "<table id='details'><tr><td style=width:35%'>Name:</td><td style='width:65%'>" + this.lastname + "  " + this.firstname + "  " + this.middlename + "</td></tr>";

        if (this.company_initial == 'ADECOM') {
            displayData += "<tr><td>Registration Number:</td><td>" + this.matric_no + "</td></tr></table>";
        } else {
            displayData += "<tr><td>Matric Number:</td><td>" + this.matric_no + "</td></tr></table>";
        }
        displayData += "</div>";

        displayData += "<div style='width:30%;text-align:right;'>";
        displayData += "<img style='border-radius:50%;' src='" + this.studentPassport + "'>";
        displayData += "</div>";

        // mywindow.document.write(document.getElementById('toBePrinted').innerHTML);

        displayData += `
                <table class='table table-bordered' style='margin-top: 10px'>
                    <thead>
                        <tr>
                            <td>COURSE TITLE</td>
                            <td>DESCRIPTION</td>
                            <td>UNITS</td>
                        </tr>
                    </thead>
                    <tbody>`;
        for (let i in courses) {
            displayData += `
                        <tr>
                            <td>${courses[i].title}</td>
                            <td>${courses[i].s_desc}</td>
                            <td>${courses[i].unit}</td>
                        </tr>
                    `;
        }
        displayData +=
            `</tbody>
                </table>
                <h5>TOTAL UNITS: ${this.totalUnits}</h5>
                `;

        displayData += "<table id='summary' style='border:none;margin-top:20px'><tr><td style='border:none;width:33.33%'><hr />Student</td><td style='border:none;width:33.33%;'><hr /> HOD</td><td style='border:none;width:33.33%;'><hr />F. Advisor</td></tr><tr><br /><br /><td style='border:none;width:33.33%'><hr />DSA</td><td style='border:none;width:33.33%;'><hr /> Student Body</td><td style='border:none;width:33.33%;'><hr />Bursar</td></tr></table>"
        displayData += "<div><p id='copyright'> &copy; " + this.company_initial + " " + yyyy + "</p></div>";

        displayData += '</body></html>';
        mywindow.document.write(displayData);
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        // mywindow.close();
        return true;
    }

    ngOnDestroy (): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);

    }


    printReceipt (pay: Payment) {
        this.receiptData = pay;

        setTimeout(() => {
            this.log
                .addLog({
                    action: "Print",
                    component: "Course Registration",
                    details: `Printed Course Registration Receipt`,
                }).subscribe(data => { });

            let prn = window.open("", "PRINT", "height=700,width=1000");
            prn.document.write(
                `<html>
        <head>
          <title>${this.studentData.matric_no} Course Reg Receipt - ${document.title} </title>
            <style>
              * {
                margin: 0;
                padding: 0;
              }

              .details-box-container {
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                min-width: 45rem;
              }

              .details-box-container>div {
                padding: .85rem;
                display: flex;
                gap: .4rem;
                flex-direction: column;
              }

              .details-box-container>div>div {
                font-weight: 500;
              }

              .signatures-container {
                display: flex;
                flex-wrap: wrap;
                margin-top: 5rem;
                justify-content: space-between;
                column-gap: 2rem;
                row-gap: 5rem;
              }
            </style>`
            );
            prn.document.write("<body>");
            prn.document.write(document.getElementById("receipt").innerHTML);
            prn.document.write("</body>");
            prn.document.write("</html>");
            prn.document.close();
            prn.focus();
            prn.onload = function () {
                prn.print();
            };
        }, 500);
    }

}
